import React from "react";
import { Navigate } from "react-router-dom";

const Secure = ({ children }) => {

  const token = localStorage.getItem("token");

  if (!token) return <Navigate to="/connexion" replace />;

  return children;
  
};

export default Secure;
